import {DateTime} from "luxon";

export function convertTime(input, zone = "local") {
    if (!input) return "";
    const s = String(input).trim();


    const formats = ["H:mm:ss", "HH:mm:ss", "H:mm", "HH:mm"];
    for (const f of formats) {
        const dt = DateTime.fromFormat(s, f, { zone });
        if (dt.isValid) return dt.toFormat("HH:mm");
    }


    const iso = DateTime.fromISO(s, { zone });
    return iso.isValid ? iso.toFormat("HH:mm") : "";
}